import type { StartUmbPageContentResponseModel } from "#/_generated/umbraco/delivery-api/models";
import { BlockGrid } from "#/_packages/umbrella/integrations/umbraco/property-components/block-grid.tsx";
import type { PageContent } from "#/_packages/umbrella/types";

export default function StartUmbPage({
	content,
}: PageContent<StartUmbPageContentResponseModel>) {
	return (
		<div>
			<BlockGrid
				prioritizeLeadingMedia
				noVerticalSpacing={content.properties?.noVerticalSpacing ?? false}
				className={"_root"}
				contentArea={content.properties?.blockGrid}
			/>
		</div>
	);
}
